import React, { Component } from 'react';
import {Link } from "react-router-dom";
import TagManager from 'react-gtm-module';
import GuestFrame from './GuestFrame.js';
import LoadingFull from './LoadingFull';
import OrangeArrow from '../img/arrow_orange.png';

export default class ConfirmEmail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			code: this.props.code,			
			code_error: null
		}

		this.sendCustomEventGTM({event:"sv_enviar_codigo_verificacion_visita"});
	}
	componentDidMount() {
		if(this.props.code) {
			this.sendCodeForm();
		} 
	}
	
	sendCustomEventGTM({event, metadata={}}){
		if (!event) return;
		TagManager.dataLayer({ 
			dataLayer:{ event, metadata } 
		});
	}
	
	sendCodeForm() {
		if(this.state.code === "") return this.setState({code_error: "Debes ingresar el código"});
		this.setState({loading: true});
		this.props.doVerifyEmail(this.state.code, (error, result) => {
			this.setState({loading: false});
			if(error) {
				return alert("error en request");
			}
			if(result.status === "error") {
				this.props.createActionNotification("Error verificando Correo electrónico", result.message, "error");
				setTimeout(() => {
					this.props.redirect("/enviar_codigo_verificacion");
				}, this.props.code?0:1500);          					
				return;
			}	
			this.props.createActionNotification("Email verificado correctamente", "Ahora inicia sesión");
			setTimeout(() => {
				this.props.redirect("/login");
			}, this.props.code?0:1500);          					

		});
		
	}	

	render() {
		if(this.props.code) return <LoadingFull />;

		return (
			<GuestFrame injectedStyles={{display:'flex', alignItems:'center', gap:16}} sloganInjectedStyles={{padding:0}}>	
				<div className="login-container-custom">
					<div className="background-flame">
						<h2 style={{fontSize: 30, fontWeight: 700, lineHeight: '120%', textAlign: 'center', color: 'white'}}>
							Se ha enviado correo de verificación
						</h2>

						<p style={{color:'white'}}>
							Hemos enviado un correo electrónico a la dirección que indicaste con las instrucciones para completar tu registro.
						</p>

				 		<GoHomeButton redirect={this.props.redirect} />

						<div className="link-white">
							<Link to={"/enviar_codigo_verificacion"} onClick={()=>this.sendCustomEventGTM({event:"sv_enviar_codigo_verificacion_click_reenviar"})}>
								<span>Reenviar correo</span>
							</Link>
						</div>
					</div>
				</div>
			</GuestFrame>
				
		);
	}
}

class GoHomeButton extends Component {
	constructor(props) {
		super(props);
		this.state = {}
	}
	sendCustomEventGTM({event, metadata={}}){
		if (!event) return;
		TagManager.dataLayer({ 
			dataLayer:{ event, metadata } 
		});
	}
	render(){
		return(
			<button 
				style={{ 
					margin:'20px auto',
					padding: '10px 40px',
					fontSize:14, 
					fontWeight:700, 
					textAlign:'center', 
					display:'flex',
					gap:10, 
					alignItems:'center',
					outline:'none',
					border:0,
					borderRadius:20,
					boxShadow:'3px 6px 10px 0px #00000040'
				}}
				onClick={() => {
					this.sendCustomEventGTM({event:"sv_enviar_codigo_verificacion_click_inicio"});
					this.props.redirect("/login");
				}}
			>
				IR AL INICIO
			
				<img 
					src={OrangeArrow} 
					alt="icono de flecha"
					style={{
						position:'relative',
						height:10,
						transition:'all 0.3s',
					}}
				/>
			</button>
		)
	}
}